import { render, staticRenderFns } from "./CourseDirectionWeb.vue?vue&type=template&id=fd464bd6&scoped=true&"
import script from "./CourseDirectionWeb.vue?vue&type=script&lang=js&"
export * from "./CourseDirectionWeb.vue?vue&type=script&lang=js&"
import style0 from "./CourseDirectionWeb.vue?vue&type=style&index=0&id=fd464bd6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd464bd6",
  null
  
)

export default component.exports